import React from "react";

import ElementsPortal from "elements/Portal";

import { useBottomSheetContext } from "./bottomSheetContext";

export type PortalProps = {
  children?: React.ReactNode;
};

export function Portal({ children }: PortalProps) {
  const { mounted } = useBottomSheetContext();
  return <ElementsPortal isMounted={mounted}>{children}</ElementsPortal>;
}
